export function generateRegisterActivityUrl(projectNumber, activityId){
	return `/tilbud/sag/${projectNumber}/registrer/${activityId}`;
}


// WEBPACK FOOTER //
// ./src/App/Util/urlhelper.js